document.addEventListener('DOMContentLoaded', function () {
  let block = document.querySelector('.testimonials-slider-box');
  if (typeof Splide !== 'undefined' && block) {
    new Splide('.testimonials-slider-box', {
      perPage: 3,
      gap: 20,
      arrows: false,
      pagination: false,
      autoplay: false,

      breakpoints: {
        1024: {
          perPage: 2,
        },
        768: {
          perPage: 1,
        }
      }
    }).mount();
  }
});
